import * as React from 'react';
import { Button, ListRow, ListItem, ListItemEmail } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

const listItemSizes = ['sm', 'md', 'lg'] as const;
type ListItemSize = (typeof listItemSizes)[number];

export function ListRowShowcase() {
  const [size, setSize] = React.useState<ListItemSize>('md');
  const [selected, setSelected] = React.useState(false);

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">ListRow</p>
        <div className="space-y-4">
          <ListRow
            title="Two-factor authentication"
            description="Add an extra layer of security to your account."
            action={
              <Button size="md" variant="outline">
                Enable
              </Button>
            }
          />
          <ListRow
            title="Data exports"
            description="Last export was 3 days ago."
            action={
              <Button size="md" variant="outline">
                Download
              </Button>
            }
          />
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">ListItem</p>
        <StateToggle options={listItemSizes} value={size} onChange={setSize} label="Size" />
        <div className="rounded-lg border border-border">
          <ListItem size={size} selected={selected} onClick={() => setSelected(!selected)}>
            <span className="type-body-sm">Inbox</span>
          </ListItem>
          <ListItem size={size}>
            <span className="type-body-sm">Drafts</span>
          </ListItem>
          <ListItem size={size}>
            <span className="type-body-sm">Sent</span>
          </ListItem>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">ListItemEmail</p>
        <div className="rounded-lg border border-border">
          <ListItemEmail
            title="Patricia Snow"
            subtitle="Quarterly report review"
            description="Please find the attached Q3 report for your review."
            timestamp="2:30 PM"
            selected
          />
          <ListItemEmail
            title="Team Updates"
            subtitle="Sprint planning notes"
            timestamp="Yesterday"
          />
          <ListItemEmail
            title="Design System"
            subtitle="Component inventory updated"
            description="Added new icons and consolidated duplicates."
            timestamp="Mar 15"
          />
        </div>
      </div>
    </div>
  );
}
